const getColorClassnames = color => {
  if (!color) {
    return null;
  }

  const colorAliases = {
    disabled: 'gray200',
    dark: 'gray800',
    default: 'gray600',
    invalid: 'red400',
    selected: 'blue400'
  };
  let colorAlias;
  Object.keys(colorAliases).forEach(alias => {
    if (alias === color) {
      colorAlias = alias;
    }
  });
  const iconColor = colorAlias ? colorAliases[colorAlias] : color;
  return `Icon-color Icon-color--${iconColor}`;
};

export default getColorClassnames;